//REACT
import React from "react"
//ROUTER-DOM
import { createBrowserRouter } from "react-router-dom"
//COMPONENTS
import { Layout, AuthLayout, PreLoader } from "../components"
//PAGES
import {
    Settings,
    CreateNewPassword,
    Error,
    ForgotPassword,
    Home,
    Login,
    Signup,
    WalletsOverview,
    WalletsWithdraw,
    Logout,
    Swap,
    Shop,
    Purchases,
    Migrate,
    ReferralPage,
    WalletsTopup,
    OurApps,
    Impersonate,
    WalletsUnclaim,
    MaintenanceMode,
} from "../pages"
import AccountType from "../pages/Auth/AccountType"
import Referral from "../pages/Auth/Referral"
import ResetPassword from "../pages/Auth/ResetPassword"
import VerifyEmail from "../pages/Auth/VerifyEmail"
import WikiPage from "../pages/WikiPage"
import HomeTransactionHistory from "../pages/TransactionHistory"
import ExchangePage from "../pages/ExchangePage"
import TransactionHistory from "../pages/TransactionHistory"

export const router = createBrowserRouter([
    {
        path: "/verify",
        element: (
            <React.Suspense fallback={<PreLoader />}>
                <AuthLayout authCheck={false} />
            </React.Suspense>
        ),
        children: [
            {
                path: "email",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <VerifyEmail />
                    </React.Suspense>
                ),
            },
        ],
    },
    {
        path: "/",
        element: <Layout />,
        children: [
            // Account Type (Personal Or Company)
            {
                path: "/",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <Home />
                    </React.Suspense>
                ),
            },
            {
                path: "/wallet",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <WalletsOverview />
                    </React.Suspense>
                ),
            },
            {
                path: "/wallet/topup",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <WalletsTopup />
                    </React.Suspense>
                ),
            },
            {
                path: "/wallet/withdraw",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <WalletsWithdraw />
                    </React.Suspense>
                ),
            },
            // {
            //     path: "/wallet/unclaimed-balance",
            //     element: (
            //         <React.Suspense fallback={<PreLoader />}>
            //             <WalletsUnclaim />
            //         </React.Suspense>
            //     ),
            // },
            {
                path: "/wallet/transaction-history",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <TransactionHistory showViewAll={false} />
                    </React.Suspense>
                ),
            },
            // {
            //     path: "/swap",
            //     element: (
            //         <React.Suspense fallback={<PreLoader />}>
            //             <Swap />
            //         </React.Suspense>
            //     ),
            // },
            // {
            //     path: "/shop",
            //     element: (
            //         <React.Suspense fallback={<PreLoader />}>
            //             <Shop />
            //         </React.Suspense>
            //     ),
            // },
            // {
            //     path: "/shop/purchases",
            //     element: (
            //         <React.Suspense fallback={<PreLoader />}>
            //             <Purchases />
            //         </React.Suspense>
            //     ),
            // },
            // {
            //     path: "/migrate",
            //     element: (
            //         <React.Suspense fallback={<PreLoader />}>
            //             <Migrate />
            //         </React.Suspense>
            //     ),
            // },
            {
                path: "/referral",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <ReferralPage />
                    </React.Suspense>
                ),
            },
            {
                path: "/settings",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <Settings />
                    </React.Suspense>
                ),
            },
            // logout
            {
                path: "/logout",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <Logout />
                    </React.Suspense>
                ),
            },
            {
                path: "/wiki",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <WikiPage />
                    </React.Suspense>
                ),
            },
            // {
            //     path: "/our-apps",
            //     element: (
            //         <React.Suspense fallback={<PreLoader />}>
            //             <OurApps />
            //         </React.Suspense>
            //     ),
            // },
            // {
            //     path:"/exchange",
            //     element: (
            //         <React.Suspense fallback={<PreLoader />}>
            //             <ExchangePage />
            //         </React.Suspense>
            //     ),
            // }
        ],
    },

    {
        path: "/auth",
        element: (
            <React.Suspense fallback={<PreLoader />}>
                <AuthLayout />
            </React.Suspense>
        ),
        children: [
            // login
            {
                path: "login",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <Login />
                    </React.Suspense>
                ),
            },
            // signup
            // {
            //     path: "signup",
            //     element: (
            //         <React.Suspense fallback={<></>}>
            //             <Signup />
            //         </React.Suspense>
            //     ),
            // },
            // {
            //     path: "signup/account-type",
            //     element: (
            //         <React.Suspense fallback={<></>}>
            //             <AccountType />
            //         </React.Suspense>
            //     ),
            // },
            // Referral Code
            // {
            //     path: "signup/referral-code",
            //     element: (
            //         <React.Suspense fallback={<></>}>
            //             <Referral />
            //         </React.Suspense>
            //     ),
            // },
            // Reset Password
            {
                path: "reset-password",
                element: (
                    <React.Suspense fallback={<></>}>
                        <ResetPassword />
                    </React.Suspense>
                ),
            },
            {
                path: "forgot-password",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <ForgotPassword />
                    </React.Suspense>
                ),
            },
            {
                path: "forgot-password/create-new-password/:email/:token",
                element: (
                    <React.Suspense fallback={<PreLoader />}>
                        <CreateNewPassword />
                    </React.Suspense>
                ),
            },
        ],
    },
    {
        path: "/impersonate",
        element: (
            <React.Suspense fallback={<PreLoader />}>
                <Impersonate />
            </React.Suspense>
        ),
    },
    {
        path: "/maintenance-mode",
        element: (
            <React.Suspense fallback={<PreLoader />}>
                <MaintenanceMode />
            </React.Suspense>
        ),
    },
    {
        path: "*",
        element: (
            <React.Suspense fallback={<PreLoader />}>
                <Error />
            </React.Suspense>
        ),
    },
])
